import {Tooltip} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {ExportCsv, ToolbarButton} from '@mui/x-data-grid-premium';

type Props = {
    /** File name without extension. */
    fileName: string;
};

/** CSV export for a `DataGridToolbar` (pass it as the toolbar's children). Exports the visible columns. */
export const DataGridCsvExportButton = ({fileName}: Props) => (
    <Tooltip title="Download as CSV">
        <ExportCsv options={{fileName}} render={<ToolbarButton color="primary"/>}>
            <FileDownloadOutlinedIcon fontSize="small"/>
        </ExportCsv>
    </Tooltip>
);
